export const FaqList = [
    {
        title: "How can I install this application?",
        desc: "Ovitae purus soda duis eu ers auctor augue ultricie conse ctetur adipisicing nisi ut aliquip ex ea commodo quat Duis aute irure dolor in reprehenderit in volupta"
    },
    {
        title: "How to update the features of Evalo?",
        desc: "Ovitae purus soda duis eu ers auctor augue ultricie conse ctetur adipisicing nisi ut aliquip ex ea commodo quat Duis aute irure dolor in reprehenderit in volupta"
    },
    {
        title: "Why Evalo is a great startup template?",
        desc: "Ovitae purus soda duis eu ers auctor augue ultricie conse ctetur adipisicing nisi ut aliquip ex ea commodo quat Duis aute irure dolor in reprehenderit in volupta"
    }
]